import script from "./CompoAPImain.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompoAPImain.vue?vue&type=script&setup=true&lang=ts"

import "./CompoAPImain.vue?vue&type=style&index=0&id=59a2809b&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59a2809b"]])

export default __exports__